import { css, setFlexDFFDC, setProps, styled } from "theme";

type Props = {
  isArabic: boolean;
};

const isArabicLang = setProps<Props>(({ isArabic }) => isArabic)(css`
  align-items: flex-end;
`);
export const SSupportPageQuestionList = styled.div<Props>`
  margin-bottom: 24px;
  gap: 8px;

  ${setFlexDFFDC};
  ${isArabicLang};
`;
